<template>
    <edit-view-base :filter="filter" :has-card-view="false" :cards="cards" :tabs="tabs" :main-form="mainForm" :claim-name="claimName" :api-method="apiMethod" :item-id="itemId" :refresh-key="refreshKey" />
</template>

<script>
    export default {
        props: [
            'filter',
            'itemId',
            'refreshKey'
        ],

        components: {
            editViewBase: () => import('../components/EditViewBase')
        },

        data() {
            return {
                cards: [
                    { title: 'Blend Supplier', apiMethod: 'BlendSuppliers', form: () => import('../forms/BlendSupplierForm'), items: [], filter: {}, dialog: false, isVisible: true, isMainCard: true },
                    { title: 'Blend Receival', apiMethod: 'BlendReceivals', parentForeignKey: 'blendSupplierId', form: () => import('../forms/BlendReceivalForm'), items: [], filter: {}, dialog: false, isVisible: true },
                ],
                tabs: [
                    { text: 'Blend Receivals', value: 'blendSupplierId', isCard: true, table: () => import('../tables/BlendReceivalsTable') },
                ],
                mainForm: () => import('../forms/BlendSupplierForm'),
                claimName: 'BlendSuppliers',
                apiMethod: 'BlendSuppliers',
            }
        }
    };
</script>
